import { cartonDisplayIdentifiersSchema } from "@redotech/redo-warehouse-common/carton-display-identifier";
import * as z from "zod";

export const previewCartonDisplayIdentifiers = {
  name: "previewCartonDisplayIdentifiers" as const,
  mutates: false,
  input: z.object({ template: z.string().trim().min(1).max(512) }),
  output: z.object({ displayIdentifiers: cartonDisplayIdentifiersSchema }),
};
